// ABOUTME: Stuart-Rush Epicor failure reasons returned by add-item and revalidation, and their user-facing text.
// ABOUTME: Keeps Epicor's own wording (e.g. "Parts not found in Epicor: X") so the seller knows the cause.

import { IntlShape } from 'react-intl';

// Why an Epicor call failed, as Epicor worded it. An absent key means that call succeeded or was not made.
export interface EpicorErrors {
    discount?: string;
    availability?: string;
}

/**
 * One message per failed Epicor call, each carrying Epicor's exact reason.
 */
export function formatEpicorErrors(
    formatMessage: IntlShape['formatMessage'],
    errors: EpicorErrors | undefined,
): string[] {
    return [
        ...(errors?.discount
            ? [
                  formatMessage(
                      {
                          id: 'cpq.epicor.discount-error',
                          defaultMessage: 'Epicor discount unavailable: {reason}',
                      },
                      { reason: errors.discount },
                  ),
              ]
            : []),
        ...(errors?.availability
            ? [
                  formatMessage(
                      {
                          id: 'cpq.epicor.availability-error',
                          defaultMessage: 'Epicor availability unavailable: {reason}',
                      },
                      { reason: errors.availability },
                  ),
              ]
            : []),
    ];
}
